import React, { useMemo } from "react";

import { Box, CardMedia, Container, IconButton } from "@material-ui/core";

import MenuItem from "api/types/MenuItem";
import MenuItemEditor, { MenuItemEditorProps } from "components/MenuItemEditor";
import PageTitle from "components/PageTitle";
import makeStyles from "hooks/makeStyles";
import useBusiness from "hooks/useBusiness";
import useCart from "hooks/useCart";
import useTranslation from "hooks/useTranslation";
import CloseCircleIcon from "icons/CloseCircle";

const useStyles = makeStyles(theme => ({
	root: {
		alignSelf: "flex-start",
		display: "flex",
		flex: 1,
		flexDirection: "column",
		padding: 0,
		[theme.breakpoints.up(480)]: {
			marginTop: "0",
			background: theme.palette.background.default,
			border: "solid 1px #E0E0E0"
		}
	},
	imageContainer: {
		width: "100%",
		height: "240px"
	},
	imageCard: {
		height: "100%",
		width: "100%"
	},
	imageContainerPlaceholder: {
		height: "240px",
		marginBottom: -theme.spacing(4)
	},
	closeButton: {
		marginLeft: 8,
		marginTop: 8,
		position: "absolute",
		padding: 0,
		textAlign: "left",
		alignSelf: "flex-start",
		zIndex: 1,
		[theme.breakpoints.up(480)]: {
			marginLeft: -16,
			marginTop: 16,
			padding: 0,
			textAlign: "left",
			zIndex: 1,
			margin: theme.spacing(2),
			alignSelf: "flex-end"
		}
	},
	closeIcon: {
		width: 16,
		height: 16,
		fill: "#fff",
		[theme.breakpoints.up(480)]: {
			fill: theme.palette.text.primary
		}
	}
}));

interface Props {
	menuItem: MenuItem;
	itemAvailable: boolean;
	onClose: () => void;
}

const MenuItemModal = ({ menuItem, itemAvailable, onClose }: Props) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const { business } = useBusiness();

	const { addToCart } = useCart();

	const handleSubmit = useMemo<MenuItemEditorProps["onSubmit"]>(
		() => ({ state }) => {
			addToCart({
				...state,
				localId: `${Math.random()}`
			});

			onClose();
		},
		[addToCart, onClose]
	);

	if (!menuItem) {
		return null;
	}

	return (
		<>
			<Container className={classes.root}>
				<PageTitle businessName={business.name} subTitle={menuItem.name} />

				{/* {menuItem.imageUrl && (
					<Box className={classes.imageContainer}>
						<CardMedia image={menuItem.imageUrl} className={classes.imageCard}></CardMedia>
					</Box>
				)} */}
				<MenuItemEditor
					menuItem={menuItem}
					itemAvailable={itemAvailable}
					submitLabel={t("addToOrder")}
					onSubmit={handleSubmit}
				/>
			</Container>
			<IconButton className={classes.closeButton} onClick={onClose}>
				<CloseCircleIcon className={classes.closeIcon} />
			</IconButton>
		</>
	);
};

export default MenuItemModal;
